export default __webpack_public_path__ + "static/media/49-cosmostree.e869ed8f.jpg";